import { useContext, useEffect, useState } from "react";
import {useParams  } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";
import LittleNotify from "../../UI/Notification/LittleNotify/LittleNotify";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";


const EditTestPage = () => {

  const {editTest, editTestPost} = useContext(AdminContext);
  const [success, setSuccess] = useState(null);
  const params = useParams()
  const [error, setError] = useState(null);
  const [question, setQuestion] = useState('');
  const [answers, setAnswers] = useState('')
  const [globalError, setGlobalError] = useState('')



  const closeSuccess = () => {
    setSuccess(null);
  };

  const isJSON = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  } 


  const submitHandler = (e) => {
    e.preventDefault();
    setError(null)
    if(question.length > 6 && answers.length > 8)
    {
      if(!isJSON(answers))
      {
        return setError('Неверный формат ответов')
      }

      editTestPost(params.test_id, answers, question).then(res => {
        if(res.status === 200)
        {
          setSuccess(res.data)
        } else 
        {
          setError(res.response.data.message)
        }
      })
    }
  }

  const questionHandler = (e) => {
    setQuestion(e.target.value)
  }

  const answersHandler = (e) => {
    setAnswers(e.target.value)
  }

  useEffect(() => {
    document.title = 'Редактирование'
    editTest(params.test_id).then(res => {
      if(res.status === 200)
      {
        setAnswers(res.data.answers)
        setQuestion(res.data.question)
      } else 
      {
        setGlobalError(res.response.data.message)
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="add-test">
      <div className="container">


        <ButtonBack shortBtn={true} userUrl="/admin/check_tests"/>
        <h1 className="add-test__text">Редактировать вопрос</h1>

        <div
          className="add-test__wrapper"
          style={{ position: "relative", minHeight: 600 }}
        >

          {!answers && !question && !globalError? (
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          ) : (
            globalError? <ErrorMessage message={globalError}/> :
            <>
              {error && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: 30,
                    color: "crimson",
                    fontSize: 22,
                  }}
                >
                  {error}
                </p>
              )}

              <form className="add-test__form" onSubmit={submitHandler}>
                
                <div className="add-test__item">
                  <label htmlFor="question">Вопрос: </label>
                  <textarea
                    type="text"
                    id="question"
                    name="question"
                    className="add-test__input "
                    placeholder="Вопрос"
                    autoComplete="off"
                    value={question}
                    onInput={questionHandler}
                    required
                  ></textarea>
                </div>

                <div className="add-test__item">
                  <label htmlFor="answers">
                    Ответы в JSON формате:
                  </label>
                  <textarea
                    type="text"
                    id="answers"
                    name="answers"
                    value={answers}
                    className="add-test__input "
                    placeholder="Ответы"
                    style={{ height: 200, fontSize: 16 }}
                    autoComplete="off"
                    onInput={answersHandler}
                    required
                  ></textarea>
                </div>

                <button className="add-test__wrapper__link">Сохранить</button>
              </form>
            </>
          )}
        </div>
      </div>
      {success && <LittleNotify title={success} close={closeSuccess} />}
    </section>
  );
};

export default EditTestPage;
